import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { NAV, SITE } from "@/lib/site";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 glass-header border-b transition-all duration-300 ${
        scrolled ? "border-sa-ink/10 shadow-[0_2px_24px_rgba(26,54,40,0.06)]" : "border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <div className="w-9 h-9 rounded-full bg-sa-ink text-sa-bg flex items-center justify-center font-serif text-lg leading-none">S</div>
          <div className="leading-tight">
            <div className="font-serif text-[18px] tracking-tight text-sa-ink">Shady Acres</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-sa-ink2">Ballarat · VIC</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[14px] tracking-wide transition-colors ${
                  isActive ? "text-sa-ink" : "text-sa-ink2 hover:text-sa-ink"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${SITE.phone_intl}`} className="text-sm text-sa-ink2 hover:text-sa-ink" data-testid="header-phone">
            {SITE.phone}
          </a>
          <button onClick={() => navigate("/book")} className="btn-primary text-sm" data-testid="header-book-btn">
            Book a stay
          </button>
        </div>

        <button
          aria-label="Open menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 grid place-items-center rounded-full border border-sa-ink/15"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={20} weight="duotone" /> : <List size={20} weight="duotone" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-sa-ink/10 bg-sa-bg/95 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-lg font-serif ${isActive ? "text-sa-ink" : "text-sa-ink2"}`
                }
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/book"); }}
              className="btn-primary w-full justify-center mt-2"
              data-testid="mobile-book-btn"
            >
              Book a stay
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
